import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
const useClientsMattersStore = defineStore('clientsMattersStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      matters: [],
      loadingMatters: false,
      clients: [],
      loadingClients: false,
      handleError
    };
  },
  actions: {
    async getMattersTable() {
      this.$patch({
        loadingMatters: true
      });
      try {
        if (!this.matters.length) {
          const url = `/matters/table`;
          const response = await axios({
            method: 'GET',
            url
          });
          this.$patch({
            matters: response.data.items,
            loadingMatters: false
          });
        } else {
          this.$patch({
            loadingMatters: false
          });
        }
      } catch (error) {
        this.handleError(error);
        this.$patch({
          loadingMatters: false
        });
      }
    },
    async getClientsTable() {
      this.$patch({
        loadingClients: true
      });
      try {
        if (!this.clients.length) {
          const url = `/clients/table`;
          const response = await axios({
            method: 'GET',
            url
          });
          this.$patch({
            clients: response.data.items,
            loadingClients: false
          });
        } else {
          this.$patch({
            loadingClients: false
          });
        }
      } catch (error) {
        this.handleError(error);
        this.$patch({
          loadingClients: false
        });
      }
    }
  }
});
export default useClientsMattersStore;